/** 小程序身份字典 member_app_role，调度端固定为运输公司 */
export const APP_ROLE_DISPATCH = 4
